export default __webpack_public_path__ + "static/media/cards.a3bb0d1f.png";